import {
  CheckmarkIcon,
  XmarkIcon,
} from "components/page-components/Icons/small"
import React, { useState } from "react"

export const RequirementsModal = ({
  requirements_modal_open,
  set_requirements_modal_open,
}) => {
  const [current_requirements_tab, set_current_requirements_tab] =
    useState(true)

  const close_requirements_modal = () => {
    set_requirements_modal_open("")
  }

  const toggle_teilnahme_tab = () => set_current_requirements_tab(true)

  const toggle_angebote_tab = () => set_current_requirements_tab(false)

  return (
    <div className={`modal ${requirements_modal_open}`}>
      <div
        className="modal-background"
        onClick={close_requirements_modal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close Message Modal"
      ></div>
      <div className="modal-content no-scrollbar">
        <div
          className="tabs is-fullwidth modal-tabs m-auto"
          style={{ maxWidth: 650 }}
        >
          <ul>
            <li className={current_requirements_tab ? "is-active" : undefined}>
              <a
                onClick={toggle_teilnahme_tab}
                onKeyPress={() => {}}
                aria-label="select auftraggeber"
                href="# "
                className="has-text-mitternachtsblau title is-6"
              >
                Teilnahme
              </a>
            </li>
            <li className={!current_requirements_tab ? "is-active" : undefined}>
              <a
                onClick={toggle_angebote_tab}
                onKeyPress={() => {}}
                aria-label="select auftraggeber"
                href="# "
                className="has-text-mitternachtsblau title is-6"
              >
                Angebote
              </a>
            </li>
          </ul>
        </div>
        <div className="box px-0 m-auto" style={{ maxWidth: 650 }}>
          <div className="columns is-mobile is-clipped is-gapless">
            <div
              className="column is-full"
              style={{
                transition: `all .3s ease`,
                transform: current_requirements_tab
                  ? "translateX(0%)"
                  : "translateX(-30%)",
                opacity: current_requirements_tab ? "1" : "0",
                visibility: current_requirements_tab ? "visible" : "hidden",
              }}
            >
              <p className="title is-7 has-text-evergabe px-3">
                Zulässige Übermittlung des Teilnahmeantrags:
              </p>
              <div className="columns">
                <div className="column is-6">
                  <p className="is-flex">
                    <span className="has-text-mitternachtsblau mr-3">
                      <CheckmarkIcon
                        {...{ color: "#0EAA2D", size: 0.5, strokeWidth: "6" }}
                      />
                    </span>
                    <span className="has-text-mitternachtsblau">
                      Elektronisch
                    </span>
                  </p>
                  <p className="is-flex">
                    <span className="has-text-mitternachtsblau mr-3">
                      <XmarkIcon
                        {...{ color: "#E70023", size: 0.5, strokeWidth: "6" }}
                      />
                    </span>
                    <span className="has-text-mitternachtsblau">
                      Schriftlich
                    </span>
                  </p>
                </div>
                <div className="column is-6">
                  <p>ccc</p>
                  <p>ddd</p>
                </div>
              </div>
            </div>
            <div
              className="column is-full"
              style={{
                transition: `all .3s ease`,
                transform: !current_requirements_tab
                  ? "translateX(-100%)"
                  : "translateX(-70%)",
                opacity: !current_requirements_tab ? "1" : "0",
                visibility: !current_requirements_tab ? "visible" : "hidden",
              }}
            >
              <p className="title is-7 has-text-evergabe px-3">2. Seite </p>
            </div>
          </div>

          <div className="has-text-right px-3">
            <button
              onClick={close_requirements_modal}
              className="button is-tertiary has-text-weight-bold"
            >
              Schließen
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
